<script setup lang="ts">
import type { ChampionshipRegistrationCustomTask } from "@/model/championship/championship-registration-custom-task"
import type { CmsPagePart } from "@/model/c-m-s/cms-page-part"
import FrontendTree from "@/pages/Cms/Frontend/FrontendTree.vue"
import type { TasksProps } from "@/pages/Tasks/Tasks/tasks-props"
import { defineTranslations } from "@/utils/defineTranslations"
import { $date, useHttpGet } from "@/vf"
import { toRefs } from "vue"

const trans = defineTranslations({
    "open_until": {
        de: "Dieser Task ist bis einschließlich {date} geöffnet.",
        en: "This task is open up to and including {date}.",
    },
})

const props = defineProps<TasksProps<ChampionshipRegistrationCustomTask>>()
const { task } = toRefs(props)

interface CustomTaskData {
    title: string | null
    closeDate: string | null
    tree: CmsPagePart[]
}

const { data } = await useHttpGet<CustomTaskData>(
    `/championship/registration/${task.value.organizationId}/custom-task/${task.value.id}`,
)
</script>

<template>
    <div class="p-5">
        <div v-if="task.state === 'open' && data?.closeDate" class="text-muted mb-4">
            {{ trans("open_until", { date: $date(data.closeDate) }) }}
        </div>

        <FrontendTree :tree="data?.tree ?? []"></FrontendTree>
    </div>
</template>
